// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { MouseEvent, ReactNode } from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

/** D-UI-3 — an icon-only button. The label is both the tooltip and the accessible name. */
export default function IconAction({ label, icon, onClick, disabled }: {
  label: string; icon: ReactNode; onClick: (e: MouseEvent<HTMLElement>) => void; disabled?: boolean
}) {
  return (
    <Tooltip title={label}>
      <span><IconButton size="small" aria-label={label} disabled={disabled} onClick={onClick}>{icon}</IconButton></span>
    </Tooltip>
  )
}
